export default {
	computed: {
		subtotal() {
			let total = 0;

			Object.keys(this.conceptTotal).forEach((i) => {
				total += parseFloat(this.conceptTotal[i]);
			});

			return parseFloat(total);
		},
		iva() {
			return parseFloat(((this.subtotal * parseFloat(this.taxes.iva)) / 100));
		},
		irpf() {
			return parseFloat(((this.subtotal * parseFloat(this.taxes.irpf)) / 100));
		},
		total() {
			return parseFloat(parseFloat((this.subtotal + this.iva) - this.irpf));
		}
	}
};
